import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main newsD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = { class: "row mb-4" }
const _hoisted_12 = { class: "col-sm-10 mx-auto list-content" }
const _hoisted_13 = {
  key: 0,
  class: "list-banner"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "board bg-white" }
const _hoisted_16 = { class: "head-row flex-grow-1 text-primary" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動介紹", -1)
const _hoisted_19 = { class: "pre-text" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動日期", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動地點", -1)
const _hoisted_22 = { class: "pre-text" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "費用性質", -1)
const _hoisted_24 = { class: "pre-text" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "主辦單位", -1)
const _hoisted_26 = { class: "pre-text" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "聯絡資訊", -1)
const _hoisted_28 = { class: "pre-text" }
const _hoisted_29 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "frce mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(history.go(-1))",
    class: "btn-anchor back",
    aria: "返回前頁"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "返回前頁")
  ])
], -1)
const _hoisted_32 = {
  key: 1,
  class: "recommend-sec"
}
const _hoisted_33 = { class: "container-lg" }
const _hoisted_34 = { class: "col-11 col-md-10 mx-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3 text-primary" }, "看其他活動", -1)
const _hoisted_36 = { class: "row row-cols-1 flex-nowrap row-cols-md-3 cols-list highlight-list" }
const _hoisted_37 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_38 = { class: "event-card-logo" }
const _hoisted_39 = { class: "event-card-info p-3 border-top" }
const _hoisted_40 = { class: "event-card-date info-text mb-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "近期活動", -1)
const _hoisted_42 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_43 = { class: "event-card-location limitLine mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ol", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "首頁",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首頁")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/list",
                      title: "活動消息",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("活動消息")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: "/events",
                      title: "近期活動",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("近期活動")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.item.name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.item.file2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: _ctx.item.file2.path,
                        class: "img-fluid",
                        alt: _ctx.item.file2.name
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.item.name), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.item.description), 1),
                  _hoisted_20,
                  _createElementVNode("p", null, _toDisplayString(_ctx.item.date + ' ' + (_ctx.item.time ? _ctx.item.time : '')), 1),
                  _hoisted_21,
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.item.location), 1),
                  _hoisted_23,
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.item.expenditure), 1),
                  _hoisted_25,
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.item.organizer), 1),
                  _hoisted_27,
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.item.contact), 1),
                  (_ctx.item.url)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_29, "網址"))
                    : _createCommentVNode("", true),
                  (_ctx.item.url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "link",
                        href: _ctx.item.url,
                        title: "另開新視窗",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(_ctx.item.url), 9, _hoisted_30))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_31
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.others.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.others, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "col align-self-stretch mb-4"
                  }, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_router_link, {
                        to: {name: 'events-detail', params: { id: item.id }},
                        title: "看其他活動",
                        class: "foo: false"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", {
                              class: "bg-wrapper",
                              style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(item.date + ' ' + (item.time ? item.time : '')), 1),
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, _toDisplayString(item.name), 1),
                            _createElementVNode("span", _hoisted_43, _toDisplayString(item.location), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}